// React
import { FunctionComponent, JSXElementConstructor, ReactElement, useCallback } from "react";
// Components
import { Page, PageConfiguration } from "@fyrstain/hl7-front-library";
// Translation
import i18n from "i18next";
// Authentication
import UserService from "../../services/UserService";
// Navigation
import { useNavigate } from "react-router-dom";
import { toPublicUrl } from "../../services/PublicUrl";

const PolusPage: FunctionComponent<{
    // The title of the page
    titleKey?: string;
    // The loading state of the page
    loading?: boolean;
    // The content of the page
    children?: ReactElement<any, string | JSXElementConstructor<any>> | undefined;
    // If the page needs login or not
    needsLogin: boolean;
}> = (props) => {

    /////////////////////////////////
    //        NAVIGATION           //
    /////////////////////////////////

    const navigate = useNavigate();

    /////////////////////////////////
    //           METHODS           //
    /////////////////////////////////

    const handleLangChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        i18n.changeLanguage(event.target.value);
    };

    const applicationItems: NonNullable<PageConfiguration["navigationBarConfigs"]["applicationItems"]> = [
        {
            logoLink: "/assets/ApplicationsLogos/Pandora.png",
            link: "/Pandora/Home",
            alt: "Pandora logo",
        },
        {
            logoLink: "/assets/ApplicationsLogos/Aceso.png",
            link: "",
            alt: "Aceso logo",
        },
        {
            logoLink: "/assets/ApplicationsLogos/Jupiter.png",
            link: "",
            alt: "Jupiter logo",
        },
        {
            logoLink: "/assets/ApplicationsLogos/Apollo.png",
            link: "",
            alt: "Apollo logo",
        },
        {
            logoLink: "/assets/ApplicationsLogos/Juno.png",
            link: "",
            alt: "Juno logo",
        },
        {
            logoLink: "/assets/ApplicationsLogos/Vulcan.png",
            link: "",
            alt: "Vulcan logo",
        },
    ];

    const fullConfig: PageConfiguration = {
        // Translation
        language: i18n.t,
        navigationBarConfigs: {
            applicationItems,
            // Application logo
            logoLink: toPublicUrl("/assets/logo.png"),
            alt: 'Polus Logo',
            // Authentication            
            authentication: {
              doLogin: UserService.doLogin,
              doLogout: UserService.doLogout,
              isAuthenticated: () => UserService.isAuthenticated() || false,
              getUserName: () => UserService.getUsername(),
            },
            // the menu items with their subItems who contains the navigation to the differents pages
            menuItems: [
                {
                    title: i18n.t('navbar.items.libraries'),
                    link: toPublicUrl("/Libraries"),
                },
            ],
            // the user items 
            // Admin, Login, Logout are the default items
            dropDownItems: [],
            // customItems: <ServerUrlField />
        },
        // the title of the page
        titleKey: props.titleKey,
        // the loading state of the page
        loading: props.loading,
        // the content of the page
        children: props.children,
        // if the page needs login or not
        needsLogin: props.needsLogin,
        footerConfigs: {
            languages: {
                default: i18n.language,
                onChange: handleLangChange,
                options: [
                    {
                        label: "English",
                        value: "en"
                    },
                    {
                        label: "Français",
                        value: "fr"
                    }
                ]
            },
            logo: [
                {
                    logoLink: "https://fyrstain.com/wp-content/uploads/2022/10/Logo_fyrstain_horyzontal.svg",
                    alt: "Horizontal logo type",
                    link: "/Home"
                },
                // {
                //     logoLink: (process.env.PUBLIC_URL ?? '') + "/assets/logo-OVH.svg",
                //     alt: "Logo OVH"
                // },
                ...(process.env.REACT_APP_DISPLAY_CLIENT_LOGO === 'true' ?
                    [
                        {
                            logoLink: "https://fyrstain.com/wp-content/uploads/2022/10/Logo_fyrstain_horyzontal.svg",
                            alt: "Horizontal logo type",
                            link: "/Home"
                        },
                        {
                            logoLink: "/assets/client_logo.jpg",
                            alt: "HL7 Europe logo"
                        }
                    ]
                    : [])
            ],
            items: [
                {
                    label: i18n.t("footer.items.about"),
                    link: toPublicUrl("/InProgress"),
                },
                {
                    label: i18n.t("footer.items.contact"),
                    link: toPublicUrl("/InProgress"),
                },
                {
                    label: i18n.t("footer.items.problemtracking"),
                    link: toPublicUrl("/InProgress"),
                },
            ],
                implementationGuide: {
                    label: i18n.t("footer.items.implementationguide"),
                    link: toPublicUrl("/ImplementationGuide"),
                },
        }
    };

    return <Page {...fullConfig} />;
};

export default PolusPage;
